import * as React from 'react';

import Folder16 from './Folder16';

export const folder16 = () => <Folder16 />;

export default {
    title: 'Icon/Fill/Folder16',
    component: Folder16,
    parameters: {
        notes: "`import Folder16 from 'box-ui-elements/es/icon/fill/Folder16';`",
    },
};
